export default "__VITE_ASSET__4b4a9c75__"